import { Popover } from "@mui/material";

interface Props {
  children: any;
  open: boolean;
  setOpen: (open: any) => void;
  anchorEl: any;
  width?: any;
}

const GKPopover = ({ children, open, setOpen, anchorEl, width }: Props) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={() => {
        setOpen(null);
      }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        style: { width: width || "14%", borderRadius: 8 },
      }}
    >
      {children}
    </Popover>
  );
};

export default GKPopover;
